import { Link, useParams } from "react-router-dom";
import {
  FaClock,
  FaLayerGroup,
  FaQuestionCircle,
  FaCheckCircle,
  FaTimesCircle,
  FaPlay,
} from "react-icons/fa";

import {
  useGetQuizByIdQuery,
  useGetQuizBlueprintQuery,
  useGetQuizStartAvailabilityQuery,
} from "../../slices/quizApiSlice";

import StartQuizButton from "../quizAttempt/components/StartQuizButton";

const StudentQuizStartScreen = () => {
  const { quizId } = useParams();

  const { data: quiz, isLoading, error } = useGetQuizByIdQuery(quizId);

  const { data: blueprint } = useGetQuizBlueprintQuery(quizId);

 const sections = blueprint?.data?.sections || [];



const {
  data: availability,
  isLoading: availabilityLoading,
} =
  useGetQuizStartAvailabilityQuery(quizId);

console.log("Start availability:", availability);
  const availableQuestions =
  availability?.data?.availableQuestions || 0;

const requiredQuestions = sections.reduce(
  (total, section) =>
    total + (section.numberOfQuestions || 0),
  0
);

const canStart =
  availableQuestions >= requiredQuestions;

  if (isLoading || availabilityLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-600">
        Loading quiz information...
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div
          className="
            rounded-xl
            bg-red-100
            p-5
            text-red-700
          "
        >
          {error?.data?.message || "Unable to load quiz"}
        </div>
      </div>
    );
  }

  return (
    <>
    
{/* <div className="bg-gray-100 p-4 mt-4 rounded">
  <pre>
    {JSON.stringify(blueprint, null, 2)}
  </pre>
</div> */}
    <div
      className="
        min-h-screen
        bg-gradient-to-br
        from-slate-100
        via-blue-50
        to-indigo-100
        p-6
      "
    >
      <div className="max-w-4xl mx-auto">
        <Link
          to="/student/quizzes"
          className="
            inline-block
            mb-6
            text-blue-600
            font-semibold
          "
        >
          ← Back to Quizzes
        </Link>

        <div
          className="
            rounded-3xl
            bg-white/90
            shadow-2xl
            p-8
          "
        >
          <h1
            className="
              text-4xl
              font-bold
              text-gray-800
            "
          >
            {quiz.name}
          </h1>

          <p className="mt-3 text-gray-600">
            {quiz.description || "No description available"}
          </p>

          <div
            className="
              grid
              md:grid-cols-3
              gap-5
              mt-8
            "
          >
            <InfoCard
              icon={<FaClock />}
              title="Duration"
              value={`${quiz.durationMinutes} minutes`}
              color="blue"
            />

            <InfoCard
              icon={<FaLayerGroup />}
              title="Blueprint"
              value={
                blueprint
                  ? `${blueprint.data?.sections?.length || 0} Sections`
                  : "Not Configured"
              }
              color="purple"
            />

            <InfoCard
              icon={<FaQuestionCircle />}
              title="Question Bank"
              value={`${availableQuestions} / ${requiredQuestions}`}
              color="green"
            />
          </div>

          <div className="mt-8">
            {canStart ? (
              <div
                className="
                  rounded-xl
                  bg-green-50
                  border
                  border-green-200
                  p-5
                  text-green-700
                "
              >
                <FaCheckCircle
                  className="
                    inline
                    mr-2
                  "
                />
                Question paper can be generated. You can start the quiz.
              </div>
            ) : (
              <div
                className="
                  rounded-xl
                  bg-red-50
                  border
                  border-red-200
                  p-5
                  text-red-700
                "
              >
                <FaTimesCircle
                  className="
                    inline
                    mr-2
                  "
                />
                Question availability is insufficient. Quiz cannot be started.
              </div>
            )}

            <div className="mt-6">
              {canStart ? (
                <StartQuizButton quizId={quizId} />
              ) : (
                <button
                  disabled
                  className="
                    rounded-xl
                    bg-gray-300
                    px-6
                    py-3
                    text-gray-600
                    font-semibold
                    flex
                    items-center
                    gap-2
                  "
                >
                  <FaPlay />
                  Start Quiz Unavailable
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
     </>
  );
};

const InfoCard = ({ icon, title, value, color }) => {
  const colors = {
    blue: "bg-blue-50 text-blue-600",
    purple: "bg-purple-50 text-purple-600",
    green: "bg-green-50 text-green-600",
  };

  return (
    <div
      className={`
        rounded-xl
        p-5
        ${colors[color]}
      `}
    >
      <div className="text-2xl">{icon}</div>

      <p className="mt-3 font-semibold text-gray-700">{title}</p>

      <p className="mt-1 font-bold text-gray-900">{value}</p>
    </div>
   
  );
};

export default StudentQuizStartScreen;
